"use client"

import { Text } from "@/elements"
import { useSession } from "@/hooks/useSession"
import { SettingsIcon as SettingsIconOutline } from "@/icons/outline/SettingsIcon"
import { SettingsIcon as SettingsIconSolid } from "@/icons/solid/SettingsIcon"
import type { NovaSession } from "@/types"
import clsx from "clsx"
import { usePathname } from "next/navigation"
import { useCallback, useState } from "react"
import { NavItemWrapper } from "./NavItemWrapper"
import { SettingsMenu } from "./SettingsMenu"
import { signOut } from "@/auth/signOut"
import { useRouter } from "next-nprogress-bar"

const SWITCH_ACCOUNT_SHARED_PATHS = ["/", "/discover", "/messages", "/settings"]
interface Props {
  forceHideLabel: boolean
  size: "default" | "lg"
  serverSession: NovaSession | null
  showProBadge: boolean
}

export const SettingsNavItem: React.FC<Props> = ({ forceHideLabel = false, size, serverSession, showProBadge }) => {
  const [openMenu, setOpenMenu] = useState(false)
  const { update: updateSession } = useSession()
  const pathname = usePathname()
  const router = useRouter()

  const isActive = openMenu || pathname?.startsWith("/settings")
  const isLarge = size === "lg"
  const currentAccount = serverSession?.account

  const toggleMenu = () => {
    // if (!openMenu) {
    // ampli.settingsOpen({
    //   account_type: serverSession?.account || "",
    // })
    // }
    setOpenMenu(!openMenu)
  }

  const handleSwitchAccount = async () => {
    const account = currentAccount === "client" ? "creative" : "client"
    if (
      (account === "client" && serverSession?.user?.client?.id) ||
      (account === "creative" && serverSession?.user?.creative?.id)
    ) {
      await updateSession({ ...serverSession, account })
      if (
        pathname &&
        (SWITCH_ACCOUNT_SHARED_PATHS.includes(pathname) ||
          SWITCH_ACCOUNT_SHARED_PATHS.some(path => pathname.startsWith(`${path}/`)))
      ) {
        router.refresh()
      } else {
        window.location.href = "/"
      }
    }

    if (account === "client" && !serverSession?.user.client?.id) {
      await updateSession({ ...serverSession, account })
      router.push("/application")
    }
    if (account === "creative" && !serverSession?.user.creative?.id) {
      await updateSession({ ...serverSession, account })
      router.push("/application")
    }
    setOpenMenu(false)
  }

  const handleSignOut = useCallback(async () => {
    await signOut({ callbackUrl: "/login" })
    setOpenMenu(false)
  }, [setOpenMenu])

  return (
    <div className="relative">
      <div className="cursor-pointer" onClick={toggleMenu}>
        <NavItemWrapper>
          {isActive ? <SettingsIconSolid /> : <SettingsIconOutline className="text-fg-3" />}
          <div className="absolute left-[44px] transition-opacity duration-200 ease-in-out md:opacity-0 lg:opacity-100">
            <Text
              variant={isLarge ? "h4" : "body1"}
              className={clsx(
                "select-none md:hidden lg:flex",
                forceHideLabel && "!hidden",
                isActive ? "text-fg-1" : "text-fg-3"
              )}>
              Settings
            </Text>
          </div>
        </NavItemWrapper>
      </div>
      <div className={clsx("absolute bottom-full z-40 mb-2 ml-3", openMenu ? "block" : "hidden")}>
        <SettingsMenu
          onToggleMenu={setOpenMenu}
          onSignOut={handleSignOut}
          onSwitchAccount={handleSwitchAccount}
          showProBadge={showProBadge}
        />
      </div>
    </div>
  )
}
